import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { VendorInvite } from '../classes/models/vendor-invite';

@Injectable({
  providedIn: 'root'
})
export class VendorInviteService {
  constructor(private http: HttpClient) {}

  saveVendorInvite(VendorInvite: VendorInvite, query = {}) {
    return this.http.post<VendorInvite>(
      `/api/v2/vendorInvite/one`,
      VendorInvite,
      { params: query }
    );
  }
}
